interface NamedWorkspace {
	id: string
	name: string
}

// Number keys pick by position, so the order has to survive reloads and sync.
export function sortWorkspacesByName<T extends NamedWorkspace>(
	workspaces: ReadonlyArray<T>,
): Array<T> {
	return [...workspaces].sort(
		(a, b) =>
			a.name.localeCompare(b.name, undefined, { sensitivity: "base" }) ||
			a.id.localeCompare(b.id),
	)
}

export const MAX_WORKSPACE_DIGIT = 9

export function workspaceDigit(index: number): string | undefined {
	return index < MAX_WORKSPACE_DIGIT ? String(index + 1) : undefined
}

export function workspaceForDigit<T>(
	workspaces: ReadonlyArray<T>,
	key: string,
): T | undefined {
	if (!/^[1-9]$/.test(key)) {
		return undefined
	}
	return workspaces[Number(key) - 1]
}
